import {
  createSelector,
  createFeatureSelector,
  combineReducers,
} from '@ngrx/store';
import * as fromWebsite from './reducers/website.reducer';
import * as fromAccount from './reducers/account.reducer';

export interface State {
  website: fromWebsite.State;
  account: fromAccount.State;
}

export const reducers = {
  website: fromWebsite.reducer,
  account: fromAccount.reducer,
};

const ecomState = createFeatureSelector<State>('Ecom');

export const getWebsiteState = createSelector(
  ecomState,
  (state) => state.website,
);
export const getWebsites = createSelector(
  getWebsiteState,
  fromWebsite.selectAllWebsites,
);
export const getIsWebsitesLoading = createSelector(
  getWebsiteState,
  (state) => state.isLoading,
);
export const getIsWebsitesUpsertings = createSelector(
  getWebsiteState,
  (state) => state.isUpserting,
);
export const getIsWebsiteDeleting = createSelector(
  getWebsiteState,
  (state) => state.isDeleting,
);

export const selectCurrentWebsiteId = createSelector(
  getWebsiteState,
  fromWebsite.getSelectedWebsiteId,
);

export const selectWebsiteEntities = createSelector(
  getWebsiteState,
  fromWebsite.selectWebsiteEntities,
);

export const selectCurrentWebsite = createSelector(
  selectWebsiteEntities,
  selectCurrentWebsiteId,
  (websiteEntities, websiteId) => websiteEntities[websiteId],
);

export const getAccountState = createSelector(
  ecomState,
  (state) => state.account,
);
export const getAccountsEntities = createSelector(
  getAccountState,
  fromAccount.selectEntities,
);
